import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Select from "react-select";

const ImportOutboundModal = ({ show, handleClose }) => {
  const [file, setFile] = useState(null);
  const [dragOver, setDragOver] = useState(false);
  const [error, setError] = useState(null);

  // Simple validation for Excel files
  const validateExcelFile = (file) => {
    const allowedTypes = [
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];
    if (!allowedTypes.includes(file.type)) {
      return "Only Excel files (.xls, .xlsx) are allowed";
    }
    return null;
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      const err = validateExcelFile(selectedFile);
      if (err) {
        setError(err);
        setFile(null);
      } else {
        setError(null);
        setFile(selectedFile);
      }
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);

    if (e.dataTransfer.files.length > 0) {
      const droppedFile = e.dataTransfer.files[0];
      const err = validateExcelFile(droppedFile);

      if (err) {
        setError(err);
        setFile(null);
      } else {
        setError(null);
        setFile(droppedFile);
      }
    }
  };

  const removeFile = () => {
    setFile(null);
    setError(null);
  };

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          <h3 className="font-16 font-weight-bold heading-color">
            Import Outbound
          </h3>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* Period & Direction */}
        <div className="d-flex gap-3">
          <Form.Group className="flex-fill">
            <Form.Label className="label-input">Period</Form.Label>
            <Select
              isMulti
              placeholder="Select"
              className="multi-select w-100"
              classNamePrefix="react-select"
              isSearchable
            />
          </Form.Group>

          <Form.Group className="flex-fill">
            <Form.Label className="label-input">Direction</Form.Label>
            <Select
              isMulti
              placeholder="Select"
              className="multi-select w-100"
              classNamePrefix="react-select"
              isSearchable
            />
          </Form.Group>
        </div>

        {/* Comment */}
        <Form.Group className="mt-3">
          <Form.Label className="label-input">Comment</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            placeholder="Type here"
            style={{
              borderRadius: "10px",
              height: "85px",
              border: "1px solid rgb(206, 212, 218)",
              padding: "4px 12px",
              fontSize: "12px",
              fontWeight: 400,
              color: "rgb(97, 121, 115)",
            }}
          />
        </Form.Group>

        <>
          <div
            onDragOver={(e) => {
              e.preventDefault();
              setDragOver(true);
            }}
            onDragLeave={() => setDragOver(false)}
            onDrop={handleDrop}
            className={`p-4 mt-3 text-center rounded border-dashed ${
                dragOver
                  ? "border border-primary bg-light"
                  : "border border-secondary"
              }`}
            style={{ cursor: "pointer" }}
            onClick={() => document.getElementById("fileInput").click()}
          >
            <img
              src="/assets/images/upload-icon.svg"
              alt="upload"
              style={{ width: "40px", marginBottom: "10px" }}
            />
            <p className="mb-1 font-13 text-color">
              Drag and drop or{" "}
              <span
                className="text-success"
                style={{ textDecoration: "underline" }}
              >
                browse
              </span>
            </p>
          </div>

          <input
            type="file"
            id="fileInput"
            accept=".xls,.xlsx"
            onChange={handleFileChange}
            style={{ display: "none" }}
          />

          {error && <div className="invalid-feedback d-block">{error}</div>}
        </>
        {/* File Upload */}
        {file && (
          <div className="d-flex align-items-center justify-content-between p-2 border rounded mt-3">
            <div className="d-flex align-items-center gap-2">
              <span className="bg-success p-2 rounded d-flex align-items-center justify-content-center">
                <img src="/assets/images/file-icon.svg" alt="" />
              </span>
              <div>
                <div className="font-10 font-weight-medium text-color mb-0">{file.name}</div>
                <small className="font-10 font-weight-normal text-color mb-0">Document</small>
              </div>
            </div>
              <img src="/assets/images/delete-icon.svg" alt="delete" onClick={removeFile} />
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button className="c-b-btn" onClick={handleClose}>
          Cancel
        </button>
        <button
          className="n-u-btn"
          disabled={!file || error}
          onClick={() => alert("File uploaded!")}
        >
          Upload
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ImportOutboundModal;
